<template>
  <div class="casino-grid-container" :data-grid-container-id="groupData.groupId">
    <template v-for="(game, i) in data">
      <div class="casino-grid-item">
        <casino-labels class="casino-labels" v-if="game && game.labels && game.labels.length > 0" :labels="game.labels"></casino-labels>
        <casino-favorites v-if="isLoggedIn" :favorite="isInFavorite(game.id)" :gameId="game.id"></casino-favorites>
        <casino-game-image :gameId="game.id"></casino-game-image>
        <casino-jackpot-and-game-info-section :gameId="game.id"></casino-jackpot-and-game-info-section>
      </div>
    </template>
  </div>
</template>
<script>
import CasinoGameImage from '@/components/igaming/partials/casinoGameImage.vue'
import CasinoJackpotAndGameInfoSection from '@/components/igaming/partials/casinoJackpotAndGameInfoSection.vue'
import CasinoFavorites from '@/components/igaming/partials/casinoFavorites.vue'
import Casino from '@/components/mixins/Casino'
import store from '@/store'
import CasinoLabels from '@/components/igaming/partials/casinoLabels.vue'
export default {
  name: 'casinoGridView',
  props: ['data', 'gamesByGroup', 'groupData'],
  mixins: [Casino],
  components: {
    CasinoLabels,
    CasinoFavorites,
    CasinoGameImage,
    CasinoJackpotAndGameInfoSection
  },
  data () {
    return {
      fallbackImageInit: false,
      gameData: false
    }
  },
  computed: {
    isLoggedIn () {
      return store.getters['isLoggedIn']
    }
  },
  methods: {
    initLazyLoadingListener () {
      let listItemElement = document.querySelector('[data-grid-container-id="' + this.groupData.groupId + '"]')
      if (!listItemElement) return
      listItemElement.addEventListener('scroll', this.lazyLoad)
      listItemElement.addEventListener('resize', this.lazyLoad)
      listItemElement.addEventListener('orientationChange', this.lazyLoad)
      this.lazyLoad()
    },
    lazyLoadFallback () {
      let self = this
      let listItemElement = document.querySelector('[data-grid-container-id="' + self.groupData.groupId + '"]')
      let lazyLoadImages = listItemElement.querySelectorAll('img.lazy')
      let lazyLoadThrottleTimeout
      if (lazyLoadThrottleTimeout) {
        clearTimeout(lazyLoadThrottleTimeout)
      }

      lazyLoadThrottleTimeout = setTimeout(function () {
        let containerId = document.querySelector('[data-gid="' + self.group.data + '"]')
        let scrollId = document.querySelector('[data-grid-container-id="' + self.groupData.data + '"]')
        let scroll = scrollId.scrollLeft
        lazyLoadImages.forEach(function (img) {
          if (img.offsetLeft < (containerId.clientWidth + scroll)) {
            img.src = img.dataset.src
            img.classList.remove('lazy')
          }
        })
        if (lazyLoadImages.length === 0) {
          listItemElement.removeEventListener('scroll', this.lazyLoad)
          listItemElement.removeEventListener('resize', this.lazyLoad)
          listItemElement.removeEventListener('orientationChange', this.lazyLoad)
        }
      }, 20)
    },
    lazyLoad () {
      let lazyLoadImages
      if ('IntersectionObserver' in window) {
        let listItemElement = document.querySelector('[data-grid-container-id="' + this.groupData.groupId + '"]')
        lazyLoadImages = listItemElement.querySelectorAll('.game-image.lazy')
        let imageObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              let image = entry.target
              image.style.backgroundImage = 'url("' + image.dataset.src + '")'
              image.classList.remove('lazy')
              imageObserver.unobserve(image)
            }
          })
        }, { rootMargin: '100px' })
        // options { threshold: 1, rootMargin: 0px 200px 0px -50%', root: listItemElement }

        lazyLoadImages.forEach(function (image) {
          imageObserver.observe(image)
        })
      } else {
        this.lazyLoadFallback()
      }
    },
    onImageError (event) {
      if (this.fallbackImageInit) return false
      document.getElementById(event.target.id).src = this.mediaServer('/static/casino/games/' + event.target.id + '/assets/gameLaunchIcon/ICON_800x600.png')
      this.fallbackImageInit = true
    },
    startLauncher (id) {
      this.gameData = this.findGameData(id)
      this.startCasinoLauncher(id)
    }
  },
  created () {
    setTimeout(() => {
      this.initLazyLoadingListener()
    }, 0)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoGridView.vue